export var TARIFF_TEXTS = {
  defaultNextBillingDateText: 'оплата спишется',
  sharingText: {
    master: 'делюсь тарифом',
    slave: 'общий с'
  },
  archive: {
    tag: 'тариф устарел',
    title: 'ваш тариф можно улучшить',
    description: 'в новых тарифах UP легко настроить количество гб и минут, и не платить за лишнее — а ещё',
    options: ['бесконечный трафик на популярные сервисы', 'тариф можно разделить с близкими и настроить общий баланс'],
    btnText: 'настроить тариф'
  },
  unifiedTariff: {
    title: 'общий тариф',
    text: 'другой номер делится с вами своим тарифом — гб, минуты и смс для вас бесплатные. вы платите только за роуминг, подключенные услуги и подписки',
    btnText: 'вернуться'
  },
  manage: {
    btnTitle: 'настроить тариф'
  },
  error: 'тариф не загрузился — нажмите, чтобы обновить'
};